import React ,{useState} from 'react'
import StudentDetails from 'modules/Students/Partials/AddNewStudentDrawer/Partials/StudentDetails'
import CourseDetails from 'modules/Students/Partials/AddNewStudentDrawer/Partials/CourseDetails'
import ContactDetails from 'modules/Students/Partials/AddNewStudentDrawer/Partials/ContactDetails'
import MarksDetails from 'modules/Students/Partials/AddNewStudentDrawer/Partials/MarksDetails'
import {
  StyledDrawer,
  FooterFlex,
  Form,
} from 'modules/Students/Partials/AddNewStudentDrawer/Style/style'
import Button from 'components/Button'
import CheckIcon from 'components/icons/CheckIcon'
import { Row } from 'antd'

const AddNewStudentDrawer = ({
  newStudentDrawer,
  setNewStudentDrawer,
  form,
  formId = 'student_form',
  title = 'Add New Student',
  sendButtonText = 'Add Student',
  dateFormat,
  onSubmitFormData,
  studentType,
  setStudentType,
  studentDOB,
  setStudentDOB,
  studentBatch,
  setStudentBatch,
  marksType,
  setMarksType,
  setSpecialization,
  specialization,
  onClearAll,
  countryCode,
  setCountryCode,
  degreeList,
  singleStudentData,
  setCourseId,
  gender,
  setGender,
  isEditingForm,
  onEditFullProfile,
}) => {
  const [specializationList, setSpecializationList] = useState([])
  const [showSpecialization, setShowSpecialization] = useState(false)
  const onChangeStudentType = e => {
    setStudentType(e.target.value)
  }
  const DrawerTitle = ({ title, isEditingForm, onEditFullProfile }) => (
    <Row justify="space-between" align="middle" >
      <span style={{ fontSize: '18px', fontWeight: 600 }}>
        {title}
      </span>

      {isEditingForm && (
        <Button.Primary
          text="View Profile"
          height="32px"
          fontsize="0.8rem"
          onClick={onEditFullProfile}
          style={{ marginRight: '15px' }}
        />
      )}
    </Row>
  )
  const content = () => {
    return (
      <div>
        <Form
          scrollToFirstError
          onFinish={onSubmitFormData}
          id={formId}
          form={form}
          layout="vertical"
        >
          <StudentDetails
            studentType={studentType}
            setStudentType={setStudentType}
            onChangeStudentType={onChangeStudentType}
            studentDOB={studentDOB}
            setStudentDOB={setStudentDOB}
            dateFormat={dateFormat}
            gender={gender}
            setGender={setGender}
            form={form}
          />
          <CourseDetails
            studentType={studentType}
            studentBatch={studentBatch}
            setStudentBatch={setStudentBatch}
            degreeOptions={degreeList}
            setMarksType={setMarksType}
            setSpecialization={setSpecialization}
            specialization={specialization}
            singleStudentData={singleStudentData}
            form={form}
            setCourseId={setCourseId}
            formId={formId}
            title={title}
            newStudentDrawer={newStudentDrawer}
            specializationList={specializationList}
            setSpecializationList={setSpecializationList}
            showSpecialization={showSpecialization}
            setShowSpecialization={setShowSpecialization}
          />
          {studentBatch?.endedOn && (
            <MarksDetails
              studentBatch={studentBatch}
              marksType={marksType}
              degreeOptions={degreeList}
            />
          )}
          <ContactDetails
            countryCode={countryCode}
            setCountryCode={setCountryCode}
          />
        </Form>
      </div>
    )
  }

  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setShowSpecialization(false)
setSpecializationList([])
            setNewStudentDrawer(false)
            onClearAll()
          }}
        />
        <Button.Primary
          htmlType="submit"
          form={formId}
          text={sendButtonText}
          icon={<CheckIcon />}
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      title={
        <DrawerTitle
          title={title}
          isEditingForm={isEditingForm}
          onEditFullProfile={onEditFullProfile}
        />
      }
      placement="right"
      closable={true}
      onClose={() => {
        setShowSpecialization(false)
        setSpecializationList([])
        setNewStudentDrawer(false)
         onClearAll()
      }}
      visible={newStudentDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default AddNewStudentDrawer
